import React, { useState, useEffect } from 'react'
import {
  Panel,
  Grid,
  Row,
  Col,
  Input,
  ControlLabel,
  SelectPicker,
  IconButton,
  Icon,
  RadioGroup,
  Radio,
  Table,
  CheckboxGroup,
  Checkbox,
  Button,
} from 'rsuite'
import { requiredFiled, isValidators } from '../../../../utils/ValidatorUtils'
import ErrorMessage from '../../../../components/message/errorMessage/ErrorMessage'
import CustomIconMessageInfo from '../../../CustomIconMessageInfo'
import CKEditorFrom from '../../../../components/forms/input/CKEditorFrom'
import InputNumberForm from '../../../../components/forms/input/InputNumberForm'
import { startLoading, doneLoading } from '../../../../utils/loading'
import InputForm from '../../../../components/forms/input/InputForm'
import { loadLocation } from '../../../../components/location/Location'
import OverlayLoader from '../../../../components/OverlayLoader/OverlayLoader'

export default function BackgroundReduceSmokingForm({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
}) {
  const { Column, HeaderCell, Cell } = Table
  const [shopPerActs, setShopPerActs] = useState([])
  const [shopAmount, setShopAmount] = useState(0)
  const [location, setLocation] = useState([])
  const [district, setDistrict] = useState([])
  const [subDistrict, setSubDistrict] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    handleLocation()

    let shopPerActs = []
    let shopCount = 0
    schema.shopInfo.acts.forEach((item) => {
      let macth
      schema.shopInfo.value.forEach((value) => {
        if (item.id == value.act.id) {
          value.shops.length > shopCount && (shopCount = value.shops.length)
          shopPerActs.push({ act: item, shops: [...value.shops] })
          macth = true
          return
        }
      })

      !macth && shopPerActs.push({ act: item, shops: [] })
    })

    //console.log('schema', schema)
    //handledDistrictSubDistrict(schema, location)

    setShopPerActs(shopPerActs)
    setShopAmount(shopCount)
    setValue(schema.shopInfo.name, shopPerActs)
    // console.log('shopPerActs', shopPerActs, 'shopCount', shopCount)
  }, [schema])

  useEffect(() => {
    // console.log('useEffect location : ', location)
    handledDistrictSubDistrict(schema)
  }, [location])

  const handledDistrictSubDistrict = async (schema) => {
    startLoading()
    let location = localStorage.getItem('location')
    let locationData = location ? JSON.parse(location) : []

    let district
    let subDistrict

    if (schema?.province?.value) {
      district = locationData?.find((obj) => obj.value === schema?.province?.value).children || []
    }

    if (schema?.district?.value && schema?.district?.value !== '-') {
      subDistrict = district.find((obj) => obj.value === schema?.district?.value).children || []
    }
    setDistrict(district)
    setSubDistrict(subDistrict)

    doneLoading()
  }

  const handleLocation = async () => {
    setIsLoading(true)
    const location = await loadLocation()
    setLocation(location)
    setIsLoading(false)
  }

  const onAddShop = () => {
    let shopSize = shopAmount ? shopAmount + 1 : 1

    let shopList = [...shopPerActs]
    for (let index = 0; index < shopList.length; index++) {
      shopList[index].shops[shopSize - 1] = false
    }

    // console.log('onAddShop shopPerActs', shopList)
    setShopPerActs(shopList)
    setShopAmount(shopSize)
    setValue(schema.shopInfo.name, shopList)
  }

  const onDeleteShop = (shop) => {
    let shopSize = shopAmount - 1

    let shopList = [...shopPerActs]

    for (let index = 0; index < shopPerActs.length; index++) {
      shopList[index].shops.splice(shop, 1)
    }

    // console.log('onDeleteShop shopPerActs', shopList)
    setShopPerActs(shopList)
    setShopAmount(shopSize)
    setValue(schema.shopInfo.name, shopList)
  }

  const genColumnShop = () => {
    const element = []
    for (let shop = 0; shop < shopAmount; shop++) {
      element.push(
        <Column width={120} align="center" key={shop}>
          <HeaderCell>
            ร้านที่ {shop + 1}
            <IconButton
              appearance="ghost"
              className="rs-btn-ghost-cancel"
              size={'sm'}
              icon={<Icon icon="trash" className="bt-gost-icon-radius-cancel" />}
              style={{ marginBottom: '5px', marginLeft: '5px' }}
              onClick={(e) => {
                onDeleteShop(shop)
              }}
            >
              ลบ
            </IconButton>
          </HeaderCell>
          <Cell style={{ display: 'flex', justifyContent: 'center' }}>
            {(rowData, index) => {
              return (
                <Checkbox
                  checked={rowData.shops[shop]}
                  onChange={(_, checked) => {
                    let shops = [...shopPerActs]
                    shops[index].shops[shop] = checked
                    setShopPerActs(shops)
                    setValue(schema.shopInfo.name, shops)
                  }}
                />
              )
            }}
          </Cell>
        </Column>
      )
    }

    return element
  }

  return (
    <>
      <Panel header="">
        <Grid fluid>
          <Row>
            <CKEditorFrom
              schema={schema.generalInfo}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          </Row>

          <Row>
            <CKEditorFrom
              schema={schema.environment}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          </Row>

          <Row>
            <Col style={{ marginTop: 10 }}>{schema.shopInfo.label}</Col>
            <CustomIconMessageInfo contents={schema.shopInfo.description} />

            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                style={{ width: '100px' }}
                onClick={() => {
                  onAddShop()
                }}
              >
                เพิ่มร้าน
              </Button>
            </div>
            <Controller
              key={schema.shopInfo.name}
              name={schema.shopInfo.name}
              control={control}
              rules={isValidators(schema.shopInfo.validators)}
              defaultValue={schema.shopInfo.value}
            />
            <Table
              wordWrap
              autoHeight
              bordered
              headerHeight={50}
              data={shopPerActs}
              style={{ marginTop: '3px' }}
            >
              <Column width={20} fixed>
                <HeaderCell></HeaderCell>
                <Cell>
                  {(_, index) => {
                    return index + 1
                  }}
                </Cell>
              </Column>
              <Column width={380} fixed>
                <HeaderCell>พรบ.ยาสูบ 2560</HeaderCell>
                <Cell>
                  {(rowData) => {
                    return rowData.act.act
                  }}
                </Cell>
              </Column>
              {genColumnShop()}
            </Table>

            <Col style={{ marginTop: 10 }}>
              <InputNumberForm
                schema={schema.nonSmokingPlace}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                labelMdLg={5}
                inputMdlg={8}
              />
            </Col>

            <CKEditorFrom
              schema={schema.nonSmokingPlaceDetail}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          </Row>

          <Row>
            <CKEditorFrom
              schema={schema.tobaccoCigarette}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          </Row>

          <Col style={{ marginTop: 10 }}>{schema.smokingProblem.label}</Col>
          <CustomIconMessageInfo contents={schema.smokingProblem.description} />

          <Row style={{ marginLeft: 10 }}>
            <InputForm
              schema={schema.smokingProblemVillage}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
            {/* <Col>
              {requiredFiled(
                schema.smokingProblemVillage.validators,
                schema.smokingProblemVillage.label
              )}
            </Col>
            <Row>
              <Col>
                <Input
                  name={schema.smokingProblemVillage.name}
                  disabled={schema.smokingProblemVillage.disabled}
                  defaultValue={schema.smokingProblemVillage.value}
                  inputRef={register(isValidators(schema.smokingProblemVillage.validators))}
                />
              </Col>
            </Row> */}
            <Row style={{ marginTop: 10 }}>
              <Col>
                {requiredFiled(schema.householdSmoking.validators, schema.householdSmoking.label)}
              </Col>
              <Col style={{ marginLeft: 10 }}>
                <InputNumberForm
                  schema={schema.allHousehold}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                  labelMdLg={8}
                  inputMdlg={6}
                />
                <InputNumberForm
                  schema={schema.allHouseholdSmoking}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                  labelMdLg={8}
                  inputMdlg={6}
                />
              </Col>
            </Row>
            <Row style={{ marginTop: 10 }}>
              <Col>{schema.smoker.label}</Col>
              <CustomIconMessageInfo contents={schema.smoker.description} />
              <Col style={{ marginLeft: 10 }}>
                <Row>
                  <Col xs={24} sm={24} md={10} lg={10}>
                    <InputNumberForm
                      schema={schema.smokerMale}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                      labelMdLg={6}
                      inputMdlg={18}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={10} lg={10}>
                    <InputNumberForm
                      schema={schema.noneSmokerMale}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                      inputMdlg={18}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={24} sm={24} md={10} lg={10}>
                    <InputNumberForm
                      schema={schema.smokerFemale}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                      labelMdLg={6}
                      inputMdlg={18}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={10} lg={10}>
                    <InputNumberForm
                      schema={schema.noneSmokerFemale}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                      inputMdlg={18}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row style={{ marginTop: 10 }}>
              <Col>
                {requiredFiled(schema.problemOfSmoking.validators, schema.problemOfSmoking.label)}
              </Col>
              <CustomIconMessageInfo contents={schema.problemOfSmoking.description} />
              <ErrorMessage error={errors[schema.problemOfSmoking.name]} />
              <Controller
                key={schema.problemOfSmoking.name}
                name={schema.problemOfSmoking.name}
                control={control}
                rules={isValidators(schema.problemOfSmoking.validators)}
                defaultValue={schema.problemOfSmoking.value}
                render={(props) => {
                  return (
                    <CheckboxGroup
                      value={props.value}
                      onChange={(value) => {
                        props.onChange(value)
                      }}
                    >
                      <Checkbox value={schema.sickOfSmoking.name}>
                        {schema.sickOfSmoking.preLabel}
                      </Checkbox>
                      {props.value.includes(schema.sickOfSmoking.name) && (
                        <div style={{ marginLeft: 30, marginTop: -10 }}>
                          <CKEditorFrom
                            schema={schema.sickOfSmoking}
                            register={register}
                            Controller={Controller}
                            control={control}
                            errors={errors}
                            setValue={setValue}
                            clearErrors={clearErrors}
                          />
                        </div>
                      )}
                      <Checkbox value={schema.sickOfCigaretteSmoke.name}>
                        {schema.sickOfCigaretteSmoke.preLabel}
                      </Checkbox>
                      {props.value.includes(schema.sickOfCigaretteSmoke.name) && (
                        <div style={{ marginLeft: 30, marginTop: -10 }}>
                          <CKEditorFrom
                            schema={schema.sickOfCigaretteSmoke}
                            register={register}
                            Controller={Controller}
                            control={control}
                            errors={errors}
                            setValue={setValue}
                            clearErrors={clearErrors}
                          />
                        </div>
                      )}
                      <Checkbox value={schema.costProblem.name}>
                        {schema.costProblem.preLabel}
                      </Checkbox>
                      {props.value.includes(schema.costProblem.name) && (
                        <div style={{ marginLeft: 30, marginTop: -10 }}>
                          <CKEditorFrom
                            schema={schema.costProblem}
                            register={register}
                            Controller={Controller}
                            control={control}
                            errors={errors}
                            setValue={setValue}
                            clearErrors={clearErrors}
                          />
                        </div>
                      )}
                    </CheckboxGroup>
                  )
                }}
              />
            </Row>

            <Row style={{ marginTop: 10 }}>
              <ErrorMessage error={errors[schema.controlCigarette.name]} />
              <Col>
                {requiredFiled(schema.controlCigarette.validators, schema.controlCigarette.label)}
              </Col>
              <Controller
                key={schema.controlCigarette.name}
                name={schema.controlCigarette.name}
                defaultValue={schema.controlCigarette.value}
                control={control}
                render={(props) => {
                  return (
                    <RadioGroup
                      inline
                      value={props.value}
                      onChange={(value) => {
                        props.onChange(value)
                      }}
                      style={{ width: '100%' }}
                    >
                      {schema.controlCigarette.options.map((item) => {
                        return <Radio value={item.value}>{item.label}</Radio>
                      })}
                      {props.value == 1 && (
                        <div style={{ marginLeft: 30, marginTop: -10 }}>
                          <CKEditorFrom
                            schema={schema.howControlCigarette}
                            register={register}
                            Controller={Controller}
                            control={control}
                            errors={errors}
                            setValue={setValue}
                            clearErrors={clearErrors}
                          />
                          <CKEditorFrom
                            schema={schema.resultControlCigarette}
                            register={register}
                            Controller={Controller}
                            control={control}
                            errors={errors}
                            setValue={setValue}
                            clearErrors={clearErrors}
                          />
                          <CKEditorFrom
                            schema={schema.obstacleControlCigarette}
                            register={register}
                            Controller={Controller}
                            control={control}
                            errors={errors}
                            setValue={setValue}
                            clearErrors={clearErrors}
                          />
                        </div>
                      )}
                    </RadioGroup>
                  )
                }}
              />
            </Row>
            <Row>
              <InputForm
                schema={schema.village}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
              />
              {/* <ErrorMessage error={errors[schema.village.name]} />
              {requiredFiled(schema.village.validators, schema.village.label)}
              <Input
                name={schema.village.name}
                disabled={schema.village.disabled}
                defaultValue={schema.village.value}
                inputRef={register(isValidators(schema.village.validators))}
              /> */}
            </Row>
            <Row style={{ marginTop: 10 }}>
              <Col xs={24} sm={24} md={8} lg={8}>
                <ErrorMessage error={errors[schema.province.name]} />
                <ControlLabel>
                  {requiredFiled(schema.province.validators, schema.province.label)}
                </ControlLabel>
                <Controller
                  key={schema.province.name}
                  name={schema.province.name}
                  control={control}
                  rules={isValidators(schema.province.validators)}
                  defaultValue={schema.province.value}
                  render={(props) => {
                    return (
                      <SelectPicker
                        size="lg"
                        data={location}
                        style={{ width: '100%' }}
                        value={props.value}
                        placeholder={`เลือก${schema.province.label}`}
                        onSelect={(value, obj) => {
                          props.onChange(value)
                          setDistrict(obj.children || [])
                          setSubDistrict([])
                        }}
                      />
                    )
                  }}
                />
              </Col>
              <Col xs={24} sm={24} md={8} lg={8}>
                <ErrorMessage error={errors[schema.district.name]} />
                <ControlLabel>
                  {requiredFiled(schema.district.validators, schema.district.label)}
                </ControlLabel>
                <Controller
                  key={schema.district.name}
                  name={schema.district.name}
                  control={control}
                  rules={isValidators(schema.district.validators)}
                  defaultValue={schema.district.value}
                  render={(props) => {
                    return (
                      <SelectPicker
                        size="lg"
                        data={district}
                        style={{ width: '100%' }}
                        value={props.value}
                        placeholder={`เลือก${schema.district.label}`}
                        onSelect={(value, obj) => {
                          props.onChange(value)
                          setSubDistrict(obj.children || [])
                        }}
                      />
                    )
                  }}
                />
              </Col>
              <Col xs={24} sm={24} md={8} lg={8}>
                <ErrorMessage error={errors[schema.subDistrict.name]} />
                <ControlLabel>
                  {requiredFiled(schema.subDistrict.validators, schema.subDistrict.label)}
                </ControlLabel>
                <Controller
                  key={schema.subDistrict.name}
                  name={schema.subDistrict.name}
                  control={control}
                  rules={isValidators(schema.subDistrict.validators)}
                  defaultValue={schema.subDistrict.value}
                  render={(props) => {
                    return (
                      <SelectPicker
                        size="lg"
                        data={subDistrict}
                        style={{ width: '100%' }}
                        value={props.value}
                        placeholder={`เลือก${schema.subDistrict.label}`}
                        onSelect={(value) => {
                          props.onChange(value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
            </Row>

            <Row style={{ marginTop: 10 }}>
              <div
                dangerouslySetInnerHTML={{
                  __html: schema.finalText,
                }}
              />
            </Row>
          </Row>
        </Grid>
        {isLoading && <OverlayLoader />}
      </Panel>
    </>
  )
}
